module.exports = __webpack_public_path__ + "img/3f_comunity.a2c73fc7.svg";